export default __webpack_public_path__ + "static/media/Default Avatar.99a5ab54.jpg";